import { useFormat } from 'vivat';

export default {
  types: {
    _increment: {
      name: 'ลำดับ',
      width: '4rem',
    },
    reason: {
      name: 'สาเหตุ',
      width: '8rem',
      filter: (val: string) => (val === 'LEAVE' ? 'ลา' : 'ซ่อมแซม'),
    },
    effectiveDate: {
      name: 'เริ่ม',
      width: '10rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDate(),
    },
    leaveUntil: {
      name: 'สิ้นสุด',
      width: '10rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDate(),
    },
    createdAt: {
      name: 'วันที่สร้าง',
      width: '10rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
    updatedAt: {
      name: 'แก้ไขล่าสุด',
      width: '10rem',
      filter: (val: string) => useFormat.date(val).displayShortThaiDateTime(),
    },
  },
  // sortable: [],
};
